/* eslint-disable consistent-return */
import React, { useState } from "react";
import {
  Card,
  Button,
  Collapse,
  FormGroup,
  Label,
  Form,
  Input,
  Badge,
  CustomInput,
} from "reactstrap";
import Select from "react-select";

import CustomSelectInput from "components/common/CustomSelectInput";
import moment from "moment";
import { useTranslation } from "react-i18next";

const answerTypes = [
  { label: "Text Area", value: "1", id: 1 },
  { label: "Checkbox", value: "2", id: 2 },
  { label: "Radiobutton", value: "3", id: 3 },
];

const SurveyQuestionBuilder = ({ expanded, item, order, deleteClick }) => {
  const [collapse, setCollapse] = useState(expanded || false);
  const [mode, setMode] = useState("edit-quesiton");
  const { t } = useTranslation();

  return (
    <Card className={`question d-flex mb-4 ${mode}`}>
      <div
        className="d-flex flex-grow-1 min-width-zero c-pointer"
        onClick={() => setCollapse(!collapse)}
      >
        <div className="card-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center">
          <div className="list-item-heading mb-0 truncate w-80 mb-1 mt-1">
            <span className="heading-number d-inline-block">{order + 1}</span>
            <strong>Mock Test: {item.test?.module}</strong>
          </div>
        </div>
        <div className="custom-control custom-checkbox pl-1 align-self-center pr-4">
          <Button
            outline
            color="theme-3"
            className={`icon-button ml-1 rotate-icon-click ${
              collapse ? "rotate" : ""
            }`}
            onClick={() => setCollapse(!collapse)}
          >
            <i
              className={
                collapse ? "simple-icon-arrow-up" : "simple-icon-arrow-down"
              }
            />
          </Button>
        </div>
      </div>

      <Collapse isOpen={collapse}>
        <div className="card-body pt-0">
          <strong>
            {t("testDetails")}{" "}
            {item.finished && (
              <>
                <Badge color="success" className="ml-1">
                  <span style={{ color: "white" }}>{t("finished")}</span>
                </Badge>
              </>
            )}
          </strong>
          <p>
            {item.finished && (
              <>
                Score: {item.score}
                {item.score != 0 && (
                  <>
                    <br />
                    Band: {item.band}
                  </>
                )}
              </>
            )}
            <br /> {t("boughtOn")} {moment(item.boughtAt).format("DD/MM/YYYY")}
          </p>
          {!item.finished && (
            <div className="text-center">
              <a href={`/mock/${item.test?._id}`}>
                <Button
                  outline
                  color="primary"
                  className="mt-3"
                  // onClick={() => handleBuy()}
                >
                  <i className="iconsminds-shopping-cart btn-group-icon" />{" "}
                  {t("takeTest")}
                </Button>
              </a>
            </div>
          )}
        </div>
      </Collapse>
    </Card>
  );
};
export default SurveyQuestionBuilder;
